const cloudinaryCloudName = process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME;

export const getVideoPlatform = (videoUrl) => {
  if (/youtube\.com|youtu\.be/.test(videoUrl)) {
    return 'youtube';
  } else if (/vimeo\.com/.test(videoUrl)) {
    return 'vimeo';
  } else if (/dailymotion\.com/.test(videoUrl)) {
    return 'dailymotion';
  } else if (/facebook\.com/.test(videoUrl)) {
    return 'facebook';
  } else if (/soundcloud\.com/.test(videoUrl)) {
    return 'soundcloud';
  } else if (/wistia\.com/.test(videoUrl)) {
    return 'wistia';
  } else if (/mixcloud\.com/.test(videoUrl)) {
    return 'mixcloud';
  } else if (/twitch\.tv/.test(videoUrl)) {
    return 'twitch';
  } else {
    return 'unknown';
  }
};

export const extractVideoId = (url, platform) => {
  switch (platform) {
    case 'youtube':
      return url.match(
        /(?:\?v=|\/embed\/|\/\d\/|\/vi?\/|youtu\.be\/|\/e\/|\/v\/|\/u\/\d\/|\/user\/\S+|\/videos\/|\/channels\/\S+\/|\/embed\/|\/c\/\S+|\/v\/|\/watch\?v=)([^#\&\?]*).*/,
      )[1];
    case 'vimeo':
      return url.match(/vimeo\.com\/(.*\/)?(\d+)/)[2];
    case 'dailymotion':
      return url.match(/video\/(\w+)/)[1];
    case 'facebook':
      return url.match(/watch\?v=(\d+)/)[1];
    case 'soundcloud':
      return url.match(/tracks\/(\d+)/)[1];
    case 'wistia':
      return url.match(/medias\/(\w+)/)[1];
    case 'mixcloud':
      return url.match(/mixes\/(\S+)/)[1];
    case 'twitch':
      return url.match(/videos\/(\d+)/)[1];
    default:
      return null;
  }
};

export const fetchThumbnail = (platform, videoUrl, videoId) => {
  let thumbnail = null;

  try {
    let apiUrl = '';
    switch (platform) {
      case 'youtube':
        // apiUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(
        //   videoUrl
        // )}&format=json`;
        // break;
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
      case 'vimeo':
        // apiUrl = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(
        //   videoUrl
        // )}`;
        // break;
        return `https://vumbnail.com/${videoId}.jpg`;
      case 'dailymotion':
        // apiUrl = `https://www.dailymotion.com/services/oembed?url=${encodeURIComponent(
        //   videoUrl
        // )}&format=json`;
        // break;
        return `http://www.dailymotion.com/thumbnail/video/${videoId}`;
      case 'facebook':
        // No direct API required for Facebook; auto-generates thumbnail
        return;
      case 'soundcloud':
        // Replace with actual SoundCloud API endpoint
        apiUrl = `SOUNDCLOUD_API_URL?track_url=${encodeURIComponent(videoUrl)}`;
        break;
      case 'wistia':
        // Replace with actual Wistia API endpoint
        apiUrl = `WISTIA_API_URL?video_url=${encodeURIComponent(videoUrl)}`;
        break;
      case 'mixcloud':
        // Replace with actual Mixcloud API endpoint
        apiUrl = `MIXCLOUD_API_URL?mix_url=${encodeURIComponent(videoUrl)}`;
        break;
      case 'twitch':
        // Replace with actual Twitch API endpoint
        apiUrl = `TWITCH_API_URL?video_url=${encodeURIComponent(videoUrl)}`;
        break;
      default:
        break;
    }

    // if (apiUrl) {
    //   const response = await axios.get(apiUrl);
    //   thumbnail = response.data.thumbnail_url;
    // }
  } catch (error) {
    console.error(`Error fetching ${platform} thumbnail`, error.message);
  }

  return thumbnail;
};

export const thumbnailFetcher = (videoUrl) => {
  const platform = getVideoPlatform(videoUrl);
  // console.log('platform: ' + platform);
  const videoId = extractVideoId(videoUrl, platform);
  // console.log('videoId', videoId);
  const thumbnail = fetchThumbnail(platform, videoUrl, videoId);
  // console.log('thumbnail', thumbnail);
  return thumbnail;
};

export const createThumbnail = (videoUrl) => {
  if (!videoUrl) {
    return null;
  }
  const isPublicUrl =
    !videoUrl.includes('cloudinary') && !videoUrl.includes(cloudinaryCloudName);
  if (isPublicUrl) {
    return thumbnailFetcher(videoUrl);
  }
  const baseVideoUrl = videoUrl.substring(0, videoUrl.lastIndexOf('.'));
  const newExtension = 'jpg';
  const newVideoUrl = `${baseVideoUrl}.${newExtension}`;
  return newVideoUrl;
};
